import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputNumberOnlyDirective } from 'src/app/shared/inputs-directive/input-number-only.directive';
import { InputCurrencyOnlyDirective } from './input-currency-only.directive';
import { InputDateStringDirective } from './input-date-string.directive';

@NgModule({
  declarations: [
    InputNumberOnlyDirective,
    InputCurrencyOnlyDirective,
    InputDateStringDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InputNumberOnlyDirective,
    InputCurrencyOnlyDirective,
    InputDateStringDirective
  ]
})
export class InputsDirectiveModule {
}
